import React from 'react';

import Container from 'react-bootstrap/Container';
import { createUseStyles } from 'react-jss';

import { Twig } from '../../types';
import Paper from '../../components/Paper';
import Text from '../../components/Text';
import Details from './DetailsCard/Details';
import Rating from './DetailsCard/Rating';
import Comments from './DetailsCard/Comments';

export interface DetailsCardProps {
  twig: Twig;
}

const DetailsCard: React.FC<DetailsCardProps> = ({ twig }) => {
  const classes = useStyles();

  return (
    <Container className={classes.customContainer}>
      <Paper withShadow={false}>
        <Details twig={twig} />
        <div className="mt-5" />
        <div className="pl-3 pr-3">
          <Text as="h4">Ratings</Text>
          <Rating twig={twig} />
        </div>
        <div className="mt-5" />
        {/* <div className="pl-3 pr-3">
          <Comments />
        </div> */}
      </Paper>
    </Container>
  );
};

const useStyles = createUseStyles({
  customContainer: {
  },
  '@media (max-width: 768px)': {
    customContainer: {
      padding: "0px"
    },
  }
})

export default DetailsCard;
